var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChannels = function SvgChannels(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 4,
    height: 4,
    rx: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 4,
    height: 4,
    rx: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.3C17 3.58203 17.582 3 18.3 3H19.7C20.418 3 21 3.58203 21 4.3V5.7C21 6.41797 20.418 7 19.7 7H18.3C17.582 7 17 6.41797 17 5.7V4.3Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 4,
    height: 4,
    rx: 1.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 4,
    height: 4,
    rx: 1.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 4,
    height: 4,
    rx: 1.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 4,
    height: 4,
    rx: 1.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 4,
    height: 4,
    rx: 1.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 4,
    height: 4,
    rx: 1.3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChannels, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "channels.ea95a1ef.svg";
export { ForwardRef as ReactComponent };